
(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name accounts.factory:ComplaintsService
     *
     * @description
     *
     */
    angular
        .module('cards')
        .factory('CardsService', CardsService);

    function CardsService($http, $q, EndpointsService, ConfigService, HelperService) {
        var CardsServiceBase = {};

        CardsServiceBase.getPage = function (params) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.cards, {
                    params: params
                })
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            },
                function (error) {
                    deferred.reject(error.data);
                });
            return deferred.promise;
        };

        CardsServiceBase.getById = function (id) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.get(response.links.cards_id.replace('{id}', id))
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            },
                function (error) {
                    deferred.reject(error.data);
                });
            return deferred.promise;
        };

        CardsServiceBase.updateCard = function (cardRequest, cardId) {
            var deferred = $q.defer();
            EndpointsService.getLinks().then(function (response) {
                $http.put(response.links.cards_id.replace('{id}', cardId), cardRequest)
                    .then(function (data) {
                        deferred.resolve(data.data);
                    }).catch(function (msg, code) {
                        deferred.reject(msg.data);
                    });
            },
                function (error) {
                    deferred.reject(error.data);
                });
            return deferred.promise;
        };

        CardsServiceBase.createEmptyRequest = function() {
            return {
                blockCard: false,
                activateCard: false,
                // POS
                limitPOS: false,
                limitAmountPOS: 0,
                limitCurrPOS: '',
                limitTrnNoPOS: 0,
                //ATM
                limitATM: false,
                limitAmountATM: 0,
                limitCurrATM: '',
                limitTrnNoATM: 0,
                // Other
                limitOther: false,
                limitAmountOther: 0,
                limitCurrOtherM: '',
                limitTrnNoOther: 0,
                // Signature
                signData: '',
                additionalSignData: ''
            }
        }
        

        return CardsServiceBase;
    }
}());
